<div class="cards">
  <mat-card class="card-proyect">
    <mat-card-header>
      <div mat-card-avatar class="example-header-image">
        <img src="./assets/img/icon-proyect.svg" width="40" height="40" alt="logo proyecto">
      </div>
      <mat-card-title>Nombre del proyecto</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="detail-item">
        <p class="subtitle-txt">Número de casos de prueba:</p>
        <p>12</p>
      </div>
      <div class="detail-item">
        <p class="subtitle-txt">Ciclos de prueba:</p>
        <p>2</p>
      </div>
      <div class="detail-item">
        <p class="subtitle-txt">Casos exitosos:</p>
        <p>8</p>
      </div>
      <div class="detail-item">
        <p class="subtitle-txt">Ciclos fallidos:</p>
        <p>4</p>
      </div>
      <div class="detail-item">
        <p class="subtitle-txt">Casos automatizados:</p>
        <p>0</p>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <a class="btn btn--outline" routerLink="/calidad/proyecto/detalle">Ver detalle</a>
    </mat-card-actions>
  </mat-card>
</div>
